import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'https://www.ridenrepair.com/api';
const VEHICLE_API = `${API_BASE}/v2/vehicle-data`;

// Simple in-memory cache
const cache = {};

async function fetchWithCache(url) {
  if (cache[url]) return cache[url];
  const { data } = await axios.get(url);
  cache[url] = data;
  return data;
}

/**
 * Get brands list (car, bike, or ev)
 * Returns: { brands: [{ id, label, value, logo }] }
 */
export const getBrands = (type) => {
  return fetchWithCache(`${VEHICLE_API}/brands?type=${encodeURIComponent(type)}`);
};

/**
 * Get models for a brand
 * Returns: { models: [{ id, label, value, imagePath }] }
 */
export const getModels = (brand, type) => {
  return fetchWithCache(`${VEHICLE_API}/models?brand=${encodeURIComponent(brand)}&type=${encodeURIComponent(type)}`);
};

/**
 * Get services for a specific vehicle + fuel type (cars/EVs)
 * Returns: { categories: [{ id, label, sub_categories: [{ services: [...] }] }] }
 */
export const getServices = (brand, model, fuelType, type) =>
  fetchWithCache(
    `${VEHICLE_API}/services?brand=${encodeURIComponent(brand)}&model=${encodeURIComponent(model)}&fuel_type=${encodeURIComponent(fuelType)}&type=${encodeURIComponent(type)}`
  );

/**
 * Get bike services by CC range
 * Returns: { services: [{ id, label, price, strikethrough_price, ... }] }
 */
export const getBikeServices = (ccRange) =>
  fetchWithCache(`${VEHICLE_API}/bike-services?cc_range=${encodeURIComponent(ccRange)}`);

/**
 * Get AC pricing tiers
 * Returns: { pricing: [...], comparison: [...] }
 */
export const getAcPricing = () =>
  fetchWithCache(`${VEHICLE_API}/ac-pricing`);

/**
 * Get Zomato rider pricing
 * Returns: { services: [...] }
 */
export const getZomatoPricing = (ccRange) =>
  fetchWithCache(`${VEHICLE_API}/zomato-pricing?cc_range=${encodeURIComponent(ccRange)}`);

/**
 * Clear the cache (useful for price updates)
 */
export const clearCache = () => {
  Object.keys(cache).forEach((key) => delete cache[key]);
};
